import General from "./General";

/*------------------------------------------------------------------
* alodokter.js
------------------------------------------------------------------*/
class Alodokter {
  static isLocalStorageReady() {
    var test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  static getLocalStorage(key = '') {
    return localStorage.getItem(key);
  }

  static setLocalStorage(key = '', val = '') {
    localStorage.setItem(key, val);
    return true;
  }

  static delLocalStorage(key = '') {
    localStorage.removeItem(key);
    return true;
  }

  static sendEventGA(key, val, par1 = null, par2 = null) {
    if (ga) {
      ga('send', 'event', key, val, par1, par2);
    }
  }

  static sendEventGA4(data) {
    if (dataLayer) {
      window.dataLayer.push(function() { this.reset(); });
      const userId = General.getCookie("user_id");
      const contentGroup = localStorage.getItem("content_group");
      if (userId) window.dataLayer.push({ user_id: userId });
      if (contentGroup) window.dataLayer.push({ content_group: contentGroup });
      dataLayer.push(data);
    }
  }

  static setAndSendPageGA(val) {
    if (ga) {
      ga('set', 'page', val);
      ga('send', 'pageview');
    }

  }

  // https://vnese.wordpress.com/2010/04/08/include-one-javascript-file-from-another-without-the-magic-of-jquery/
  static getScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    // most browsers
    script.onload = callback;
    // IE 6 & 7
    script.onreadystatechange = function() {
      if (this.readyState == 'complete') {
        callback();
      }
    }
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  // Restricts input for the given textbox to the given inputFilter.
  static setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
      textbox.addEventListener(event, function() {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
      });
    });
  }

  static setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  static getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
  }
}

export default Alodokter;